module.exports = __webpack_public_path__ + "img/hfb_brand.f56dc4c0.png";